module.exports = __webpack_public_path__ + "static/media/favicon-notification.9c8de781.png";